<div class="verification-label" data-qa="genesys-call-log_verification-label">
  <div class="verification-label__label">
    <label class="verification-label__label-text" [for]="labelFor">
      {{ label }}
      <horizon-icon
        *ngIf="hasTooltip"
        [iconGroup]="'tooltip'"
        [iconName]="'warning'"
        [title]="tooltipText"
        [color]="globalSettings.colors.warningColor"
        [size]="'16'"
      ></horizon-icon>
    </label>
  </div>
  <div class="verification-label__verification">
    <radio-validation-label
      [groupName]="labelFor"
      [isDisabled]="isDisabled"
      [valueSelected]="valueSelected"
      (valueChanged)="onSwitchChanged(labelFor, $event)"
    ></radio-validation-label>
  </div>
</div>
